<template>
     <div class="financialcontrol-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Financial Control" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="financialcontrol-id" 
                type="hidden" 
                v-model="financialcontrol.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Date:"
                    label-for="financialcontrol-date_financial_control"
                    >
                    <b-form-input
                    id="financialcontrol-date_financial_control"
                    type="date"
                    v-model="financialcontrol.date_financial_control"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Financial for:" 
                        label-for="financialcontrol-entity_id_financial_control">
                        <b-select 
                            id="financialcontrol-entity_id_financial_control"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="entitys" 
                            v-model="financialcontrol.entity_id_financial_control" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                 <b-col md="8" sm="12">
                    <b-form-group 
                        label="Category:" 
                        label-for="financialcontrol-operation_level_one_id_financial_control">
                        <b-select 
                            id="financialcontrol-operation_level_one_id_financial_control"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operationslevelones" 
                            v-model="financialcontrol.operation_level_one_id_financial_control" 
                            />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Due Date:"
                    label-for="financialcontrol-due_date_financial_control"
                    >
                    <b-form-input
                    id="financialcontrol-due_date_financial_control"
                    type="date"
                    v-model="financialcontrol.due_date_financial_control"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                </b-form-group>
            </b-col>
             <b-col md="3" sm="12">
                    <b-form-group 
                            label="Reference:" 
                            label-for="financialcontrol-reference_financial_control">
                        <b-form-input id="financialcontrol-reference_financial_control" 
                            type="text"
                            v-model="financialcontrol.reference_financial_control" 
                            size="sm"
                            placeholder="Reference..." />
                    </b-form-group>
                    </b-col>
             <b-col md="2" sm="12">
                <b-form-group
                    label="Value:"
                    label-for="financialcontrol-value_financial_control"
                >
                    <b-form-input
                        id="financialcontrol-value_financial_control"
                        type="number"
                        v-model="financialcontrol.value_financial_control"
                        size="sm"
                        step="0.02"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                    />
                </b-form-group>
             </b-col>
             </b-row>
            <b-row>
                 <b-col md="8" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="financialcontrol-comments_financial_control">
                        <b-form-textarea id="financialcontrol-comments_financial_control"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="financialcontrol.comments_financial_control"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>
           
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadFinancialControls(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                  
                </b-col>
            </b-row>
            <br>
            
        <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <div class="stats">
                <Stat
                    title="Not Received"
                    :value="this.total_plot_open"
                    color="#d54d50"
                />
                <Stat
                    title="Receipt"
                    :value="this.total_plot_closed"
                    color="#3bc480"
                />
                <Stat title="Total" :value="this.total_plot" color="#3282cd" />
            </div>
        </b-row>
        <hr />
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Operation:"
                        label-for="financialcontrol-operation_id"
                    >
                        <b-form-select
                            id="financialcontrol-operation_id"
                            @input="[loadOperationsLevelOnes(),loadFinancialControls()]"
                            size="sm"
                            :options="operations"
                            v-model="operation_id"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group
                        label="Category:"
                        label-for="financialcontrol-operation_level_one_id"
                    >
                        <b-form-select
                            id="financialcontrol-operation_level_one_id"
                            size="sm"
                            :options="operationslevelones"
                            v-model="operation_level_one_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
             <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Due Date:"
                    label-for="orderservice-start_date"
                    >
                    <b-form-input
                    id="orderservice-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Due Date:"
                    label-for="orderservice-end_date"
                    >
                    <b-form-input
                    id="orderservice-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Situation">
                    <b-form-radio-group
                        size="lg"
                        v-model="receipt"
                        @input="loadFinancialControls"
                        :options="optionsReceipt"
                        name="orderservice-receipt"
                    ></b-form-radio-group>  
                    </b-form-group>    
                </b-col>
             </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                     <b-col md="8" sm="12">
                        <b-form-group >
                            <b-form-input id="financialcontrol-entity_for_financial_control" 
                                type="text"
                                v-model="search" 
                                size="sm"
                                placeholder="Search by Financial for..." />
                        </b-form-group>
                    </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.settlement_date_financial_control"
                        title = "Receipt" 
                        size="sm" 
                        variant="light" 
                        @click="[openModalReceipt(data.item)]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>          
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                      <b-button
                        title = "Attachment Financial Control"
                        size="sm"
                        @click="setFinancialControl(data.item)"
                        variant="light"
                        class="mr-2 mt-2 fa fa-plus"
                        v-b-modal.modalFile
                        > 
                    </b-button>
                    <b-button
                        title="View File"
                        size="sm"
                        variant="light"
                        v-if="data.item.storage_id_financialcontrol > 0"
                        @click="loadUrl(data.item)"
                        class="mr-2 mt-2"
                    >
                    <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
         <b-modal
            id="modalReceipt"
            ref="modal"
            title-tag="h6"
            title="Receipt"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="showMsgBoxReceipt"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Settlement Date:"
                            label-for="financialcontrol-settlement_date_financial_control"
                        >
                            <b-form-input
                                id="financialcontrol-settlement_date_financial_control"
                                type="date"
                                v-model="financialcontrol.settlement_date_financial_control"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="5" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="financialcontrol.deposit_bank_financial_control"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="financialcontrol-deposit_bank_financial_control"
                                />
                                <label
                                    class="form-check-label"
                                    for="financialcontrol-deposit_bank_financial_control"
                                >
                                    Bank Transfer?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
         </b-modal> 
        <b-modal
        id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>   
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Stat from '../home/Stat'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'FinancialControlSearch',
    components: {PageTitle,Stat },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                financialcontrol: {},
                owners:[],
                financialcontrols: [],
                financialcontrolcontracts:[],
                entitys: [],
                operations:[],
                operationslevelones:[],
                perPage: 20,
                currentPage: 1,
                total_plot_closed: 0,
                total_plot_open: 0,
                total_plot: 0,
                 isBusy: false,
                 showTable: false,
                 start_date: null,
                 end_date: null,
                 receipt: null,
                 operation_id: null,
                 operation_level_one_id: null,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {key: 'date_financial_control',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_entity', label: 'Name', sortable: false ,variant: 'light'},
                    { key: 'reference_financial_control', label: 'Reference', sortable: false ,variant: 'light'},
                    {key: 'due_date_financial_control',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_financial_control', label: 'Financial Control Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'bank_deposit_financial_control', label: 'Bank Transfer', sortable: false, variant: 'light',
                        formatter: value => value ? 'Yes' : 'No' },  
                    { key: 'settlement_date_financial_control',label: 'Settlement Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'comments_financial_control', label: 'Comments', sortable: false ,variant: 'light'},
              
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
               
            }
        },
        computed: {
            filteredList() {
                return this.financialcontrols.filter(financialcontrol => {
                    return financialcontrol.name_entity.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.financialcontrols.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             async showMsgBoxReceipt() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to receipt the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.save()
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadFinancialControls(){
                const url = `${baseApiUrl}/financialcontrolssearchdate/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&receipt=${this.receipt}&operation_id_financial_control=${this.operation_id}`
                axios(url).then(res =>{
                     this.financialcontrols = res.data
                      this.isBusy = false
                })

                this.loadFinancialControlTotal()
                this.loadFinancialControlOpen()
                this.loadFinancialControlClosed()
            },
            alterModo() {

                if (!this.operation_id) {
                    this.$toasted.global.defaultWarning({ msg: 'Operation filter not selected' })
                }else{
                        this.mode = 'save'
                    this.financialcontrol = {}
                    this.$refs.searchFocus.focus();
                }
                
            },
             reset() {
                this.mode = 'insert'
                this.loadFinancialControls()              
                this.financialcontrol = {}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/financialcontrolsapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadFinancialControls()

                        })
                        .catch(showError)

           },
             async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/financialcontrolscanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadFinancialControls()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.financialcontrol.id ? 'put' : 'post'
                const id = this.financialcontrol.id ? `/${this.financialcontrol.id}` : ''

                this.financialcontrol.user_id_financial_control = this.user.id
                this.financialcontrol.company_id_financial_control = this.compan.id
                this.financialcontrol.operation_id_financial_control = this.operation_id
                
                await axios[method](`${baseApiUrl}/financialcontrols${id}`, this.financialcontrol)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.financialcontrol.id
                    axios.delete(`${baseApiUrl}/financialcontrols/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadFinancialControl(financialcontrol, mode = 'save') {
                this.mode = mode
                 if(financialcontrol.date_financial_control) financialcontrol.date_financial_control = this.formatDate(financialcontrol.date_financial_control)
                 if(financialcontrol.due_date_financial_control) financialcontrol.due_date_financial_control = this.formatDate(financialcontrol.due_date_financial_control)
                 if(financialcontrol.settlement_date_financial_control) financialcontrol.settlement_date_financial_control = this.formatDate(financialcontrol.settlement_date_financial_control)
                this.financialcontrol = { ...financialcontrol }
                this.$refs.searchFocus.focus();
     
            },
            setFinancialControl(financialcontrol){
                 this.financialcontrol = { ...financialcontrol }
            },
            openModalReceipt(item) {
                this.financialcontrol = {...item}
                this.$bvModal.show('modalReceipt')
            },
            loadEntitys(){
                const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.entitys = res.data.map(type => {
                        return { value: type.id, text: type.name_entity + ' - ' + type.cnpj_cpf }
                    })
                
                })
            },
            async loadFinancialControlTotal() {
            this.total_plot = 0

                const url = `${baseApiUrl}/financialcontrolsearchdatetotal/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&operation_id_financial_control=${this.operation_id}`
                await axios.get(url).then(res => {
                    this.total_plot = this.formatPrice(
                        res.data[0].portion_total
                    )
                })
            
             },
            async loadFinancialControlOpen() {
            this.total_plot_open = 0

                const url = `${baseApiUrl}/financialcontrolsearchdateopen/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&operation_id_financial_control=${this.operation_id}`
                await axios.get(url).then(res => {
                    this.total_plot_open = this.formatPrice(
                        res.data[0].portion_open
                    )
                })
            
             },
            async loadFinancialControlClosed() {
            this.total_plot_closed = 0

                const url = `${baseApiUrl}/financialcontrolsearchdateclosed/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&operation_id_financial_control=${this.operation_id}`
                await axios.get(url).then(res => {
                    this.total_plot_closed = this.formatPrice(
                        res.data[0].portion_closed
                    )
                })
            
             },
            loadUrl(item){
                window.open(item.url_file)
            },
            async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
                async getLastStorageFile() {
                    const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                        await axios(url).then(
                            (res) =>
                            (this.financialcontrol = {
                                ...this.financialcontrol,
                                storage_id_financialcontrol: res.data.id,
                            })
                        );
                },    
                loadOperation() {
                    const url = `${baseApiUrl}/operations`
                        axios.get(url).then(res => {
                        this.operations = res.data.map(operation => {
                        return {
                        value: operation.id,
                        text: operation.name_operation
                        }
                        })
                    })
                },
                loadOperationsLevelOnes() {
                    const url = `${baseApiUrl}/operationslevelones/${this.operation_id}/?company_id=${this.compan.id}`
                        axios.get(url).then(res => {
                            this.operationslevelones = res.data.map(operationslevelone => {
                            return {
                            value: operationslevelone.id,
                            text: operationslevelone.name_operation_level_one
                        }
                        })
                    })
                },

        },
        mounted(){

                this.start_date = moment().format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadFinancialControls()
            this.loadEntitys()
            this.loadOperation()
            this.showTable = true
        }
}
</script>

<style>


    .financialcontrol-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .financialcontrol-search button{
        font-size: 0.75rem;
    }

     .financialcontrol-search select{
        font-size: 0.75rem;
    }

    .financialcontrol-search input{
        font-size: 0.75rem;
    }

     .financialcontrol-search textarea{
        font-size: 0.75rem;
    }

    .financialcontrol-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalReceipt {
        font-size: 0.75rem;
    }

    #modalReceipt button{
        font-size: 0.75rem;
    }

     #modalReceipt input{
        font-size: 0.75rem;
    }

      #modalReceipt select{
        font-size: 0.75rem;
    }

      #modalReceipt label{
        font-size: 0.75rem;
        color: black;
    }

    #modalFile {
    font-size: 0.75rem;
    }

    #modalFile button{
    font-size: 0.75rem;
    }


    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
